import React, { Component } from 'react';
import { Jumbotron, Container } from 'reactstrap';
import { withApollo } from 'react-apollo';
import { GET_PENDING_STICKERS, GET_MONTHLY_STICKERS } from '../../query/query';
import Sticker from './sticker';

class ModeratorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pendingStickers: [],
      monthlyStickers: [],
    };
  }

  getPendingStickers() {
    this.props.client.query({
      query: GET_PENDING_STICKERS,
    }).then(({ data }) => {
      if (data.pendingStickers) {
        this.setState({
          pendingStickers: data.pendingStickers,
        });
      }
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  getMonthlyStickers() {
    this.props.client.query({
      query: GET_MONTHLY_STICKERS,
    }).then(({ data }) => {
      if (data.savMonthlyAcceptedCommunityStickers) {
        this.setState({
          monthlyStickers: data.savMonthlyAcceptedCommunityStickers,
        });
      }
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  componentWillMount() {
    this.getPendingStickers();
    this.getMonthlyStickers();
  }

  render() {
    return (
      <Jumbotron>
        <h3 className="display-4">
          Stickers
        </h3>
        <hr className="my-2" />
        <h4>Stickers accepted this month</h4>
        Community stickers validated this month ('Right-Click' + 'Save Image As' to download)
        <Container>
          {
            this.state.monthlyStickers.map(s => <img src={s.base64} style={{ height: 75, width: 150 }} alt="sticker"/>)
          }
        </Container>
        <hr className="my-2" />
        <h4>Pending stickers</h4>
        <Container>
          {
            this.state.pendingStickers.map(s => <Sticker key={s._id} sticker={s} client={this.props.client} />)
          }
        </Container>
      </Jumbotron>
    );
  }
}

export default withApollo(ModeratorPage);



// WEBPACK FOOTER //
// ./src/components/moderator/moderator.js